import { CreditCardName } from '@/components/modules/CreditCard/Detail/Overview/hooks/useIberiaCardParams';

interface IberiaCardTypeConfiguration {
  cardType: number;
  cardBrand: number;
  cardProduct: number;
}

export const CreditCardNameMap = {
  toTypeConfiguration: (creditCardName: CreditCardName): IberiaCardTypeConfiguration => {
    return IBERIA_CARDS_CREDIT_CARD_TYPES_BY_ID[creditCardName];
  },

  toName: (id: number): CreditCardName => {
    const index = Object.values(IBERIA_CARDS_CREDIT_CARD_TYPES_BY_ID).findIndex((card) => card.cardType === id);

    if (index === -1) {
      throw new Error('Card type is not a recognized IBERIA CARD type');
    }

    return (Object.keys(IBERIA_CARDS_CREDIT_CARD_TYPES_BY_ID) as CreditCardName[])[index];
  },
};

const IBERIA_CARDS_CREDIT_CARD_TYPES_BY_ID: Record<CreditCardName, IberiaCardTypeConfiguration> = {
  [CreditCardName.ZENIT]: {
    cardType: 71,
    cardBrand: 4,
    cardProduct: 7131,
  },
  [CreditCardName.AIRE]: {
    cardType: 72,
    cardBrand: 4,
    cardProduct: 7231,
  },
  [CreditCardName.ICON]: {
    cardType: 45,
    cardBrand: 4,
    cardProduct: 4511,
  },
};
